import axios from "axios";
import { Component } from "react";
import GeneralBloc from "../bloc/general_bloc";
import BaseWebService from "./base_web_service";
import DOMPurify from "dompurify";

export default class ListingWebServices extends Component {
  static async getSubmittedDocuments(docClass, recMap) {
    let headers = await BaseWebService.headers(docClass);
    let url=DOMPurify.sanitize(GeneralBloc.encodeAndDecodeURL(
      BaseWebService.baseUrl() + `/submittedDocs/${docClass}/${recMap}`
    ));
    let resp = await axios.get(
      url,
      { headers: headers }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  static async getProposalOrQuotationListing(    
    payload,
    module
  ) {
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/client/getQuoOrPropListing?category=${module.toUpperCase()}`);
    let resp = await axios.post(
      url,
      payload,
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);

    return response;
  }

  static async getProposalAndQuotationListing(clientId,payload,value) {
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/client/transaction/listing?id=${clientId}&value=${value}`);
    let resp = await axios.post(
      url,
      payload,
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);

    return response;
  }

  static async getListing(
    id,
    // token,
    payload,
    role,
    searchCriteria
  ) {
    let header = await BaseWebService.standardHeaders(role);
    /* if(role=="cac"){
      role="supervisor"
    } */
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/${role}/listing?value=${searchCriteria}`);
    let resp = await axios.post(
      url,
      payload,
      {
        headers: header,
      }
    );
    
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    
    return response;
  }

  static async getListingSearch(
    id,
    // token,
    payload,
    role,
    searchCriteria
  ) {
    let header = await BaseWebService.standardHeaders(role);
    
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/${role}/${id}`);
    let resp = await axios.post(
      url,
      payload,
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);

    return response;
  }
  

  static async getListingCount(
    // token,
    payload,
    id,
    module
  ) {
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/${module}/${module}_count`);
    let resp = await axios.post(
      url,
      payload,
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);

    return response;
  }

  static async getListingDetail(payload) {
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/quotation/quotation_detail`);
    let resp = await axios.post(
      url,
      payload,
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }
}
